require("./bootstrap");

// import and run sticky header module
require("./sticky-header");
$(function (readyEvent) {
    $(window).trigger("scroll");
});

// import event carousel module
require("./event-carousel");

// import order popup scripts
require("./show-modal");

// import order summary scripts
require("./order-summary");

// import submit message scripts
require("./submit-message");
